import { faDownload } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Typography } from "@mui/material"
import { useApi } from "auth/useApi3"
import { useParams } from "react-router-dom"

import { apiEndpoints } from "generated/apiEndpoints"
import { useTranslation } from "react-i18next"

const LegacyResultDescription = () => {
  const [downloadResult, downloadApi] = useApi()
  const params = useParams()
  const { t } = useTranslation()
  return (
    <>
      <Typography marginBottom={3}>
        {t(
          "learning.result.titles.imported_result",
          "This is an imported result from a previous system and the detailed specification can be downloaded by clicking the button below."
        )}
      </Typography>

      <Button
        color="primary"
        variant="contained"
        disabled={downloadResult.status === 1}
        startIcon={<FontAwesomeIcon icon={faDownload} />}
        onClick={() => {
          downloadApi.getBlob(
            apiEndpoints.learningadmin.downloadlegacypdf.replace("{id}", params.id),
            "testresultat.pdf"
          )
        }}>
        {t("learning.result.titles.download_test_result", "Download test results")}
      </Button>
    </>
  )
}
export default LegacyResultDescription
